import axios from "@/api/axiosInstance";
import { FetchEmployeeDirectoryDataResponse } from "./types";

export const fetchEmployeeDirectoryData =
  async (): Promise<FetchEmployeeDirectoryDataResponse> => {
    const response = await axios.get<FetchEmployeeDirectoryDataResponse>(
      "/api/private/employee-directory",
    );
    return response.data;
  };
